/**
 * StickyFooterCTA — mobile-first sticky bottom action row.
 *
 * Ensures the primary "Continue / Save" button is always reachable even when the
 * iOS Safari address bar pops up or the on-screen keyboard pushes content up.
 * Respects safe-area-inset-bottom on notched phones.
 *
 * Place once per page at the end of the scrollable content. Children should
 * be flex-arranged Back + Continue (or just a Save button).
 */
export default function StickyFooterCTA({ children, className = "", testid }) {
  return (
    <div
      data-testid={testid || "sticky-footer-cta"}
      className={`sticky bottom-0 left-0 right-0 z-30 -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] bg-paper-50/90 backdrop-blur supports-[backdrop-filter]:bg-paper-50/70 border-t border-paper-200 ${className}`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-end gap-3 flex-wrap">
        {children}
      </div>
    </div>
  );
}
